import script from "./150-m.vue?vue&type=script&setup=true&lang=js"
export * from "./150-m.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__